<template>
  <div class="header">
    <div class="container">
      <div class="header-left">
        <div class="logo">
          <router-link :to="{name:'index'}"></router-link>
        </div>
        <div class="nav">
          <router-link :to="{name:'index'}">专业家云平台</router-link>
          <a href="http://www.smarthse.cn/#/" target="_blank">智慧职安科技</a>
        </div>
      </div>
      <div class="header-right">
        <div class="header-link" v-if="!getuserName">
          <router-link :to="{name:'login'}">登录</router-link>
          <router-link :to="{name:'register'}">注册</router-link>
        </div>
        <div class="userinfo" v-if="!!getuserName">
<!--          <span class="icon icon-bell" @click="jumpNotice" >-->
<!--            <span class="reddot" :class="{'w28':getmessageNum>99}" v-show="getmessageNum>0">{{getmessageNum}}</span>-->
<!--          </span>-->
          <div class="avatar">
            <img v-show="!!getimgSrc" :src="getimgSrc" @click="enterCenter" alt="" />
            <img v-show="!getimgSrc" src="/static/img/public/headerimg-default.png" @click="enterCenter" alt="" />
          </div>
          <div class="welcome">
            <p>欢迎光临！</p>
            <el-tooltip :content="getshowName" placement="bottom" effect="light">
              <p class="username" @click="enterCenter">{{getshowName}}</p>
            </el-tooltip>
          </div>
          <button class="quitbtn btn" @click="exit">退出</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'zHeader',
    data () {
      return {
        unreadNum: null, // 未读消息数
      };
    },
    mounted: function () {
      // if(!!this.getusertype) {
      //   this.getUnreadNum();
      // }
    },
    methods: {
      exit() {
        window.localStorage.removeItem("TOKENID"); // 清除本地存储的token
        this.$store.commit("setuserName", ""); // 清除用户名
        this.$store.commit("setshowName", ""); // 清除显示名
        this.$store.commit("settoken", ""); // 清除token
        this.$store.commit("setmessageNum", ""); // 清除未读消息数
        this.$store.commit("setusertype", ""); // 清除用户类型
        this.$store.commit("setimgSrc", ""); // 清除头像
        this.$store.commit("setregType", ""); // 清除注册类型
        this.$router.push({ path: "/index" }); // 跳转首页
      },
      // jumpNotice() {
      //   if (this.getusertype === "company") {
      //     this.$router.push("/companyCenter-notice");
      //     return ;
      //   }
      //   this.$router.push("/userCenter-info");
      // },
      enterCenter() {
        if (this.getusertype === "company") {
          this.$router.push("/companyCenter-info");
          return ;
        }
        this.$router.push("/userCenter-manage");
      },
      // getUnreadNum() {
      //   let url="";
      //   if (this.getusertype === "company") {
      //     url = "/corp/message/num";
      //   } else {
      //     url = "/uc/message/NotReadMsgNum";
      //   }
      //   this.$ajax.post(url).then((res) => {
      //     if(res && res.state && res.state.value === 0) {
      //       this.unreadNum = res.result;
      //       this.$store.commit('setmessageNum', this.unreadNum);
      //     }
      //   }).catch((err) => {
      //     console.log(err);
      //   });
      // },
    },
    computed: {
      ...mapGetters([
        'getuserName',
        'getshowName',
        'getimgSrc',
        // 'getmessageNum',
        'getusertype',
      ])
    }
  }
</script>

<style scoped>
  //.w28 { width: 28px; }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    overflow: hidden;
    z-index: 999;
  }

  .header .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .header .container .header-left {
    display: flex;
    align-items: center;
  }

  .header .logo {
    cursor: pointer;
  }

  .header .logo a {
    display: block;
    width: 254px;
    height: 40px;
    background: url(/static/img/logo.png) no-repeat 0 center;
  }

  .header .nav {
    display: flex;
    align-items: center;
    margin-left: 50px;
    box-sizing: border-box;
  }

  .header .nav a {
    display: block;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    white-space: nowrap;
  }

  .header .nav a:first-of-type {
    color: #3277FE;
  }

  .header .nav a + a {
    margin-left: 50px;
  }

  .header .container .header-right {
    margin-left: 50px;
  }

  .header-link {
    display: flex;
    align-items: center;
  }

  .header-link a {
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    color: #666;
    white-space: nowrap;
  }

  .header-link a:first-child {
    color: #3277FE;
  }

  .header-link a + a {
    margin-left: 20px;
  }

  .header .userinfo {
    display: flex;
    align-items: center;
  }

  .header .userinfo .icon-bell {
    display: block;
    position: relative;
    margin-right: 20px;
    width: 26px;
    height: 70px;
    background: url(/static/img/public/icon-bell.png) no-repeat center center;
    cursor: pointer;
  }

  .header .userinfo .icon-bell .reddot {
    display: block;
    position: absolute;
    top: 6px;
    right: -16px;
    width: 20px;
    height: 20px;
    background: #ff4343;
    color: #fff;
    line-height: 1.5;
    text-align: center;
    border-radius: 100%;
    z-index: 99;
    animation: scaledot ease-in-out 3s infinite;
  }

  @keyframes scaledot {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.2);
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.2);
    }
  }

  .header .userinfo .avatar {
    width: 40px;
    height: 40px;
    text-align: center;
    border-radius: 100%;
    border: 1px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
  }

  .header .userinfo img {
    display: inline-block;
    width: 100%;
  }

  .header .userinfo .welcome {
    margin: 12px;
    max-width: 140px;
    line-height: 22px;
  }

  .header .userinfo .username {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }

  .header .userinfo .quitbtn {
    margin-left: 20px;
    width: 70px;
    height: 30px;
    color: #fff;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
    background: #00aaff;
    border-radius: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue